import { api } from './client';
import type { FollowedTrip } from '../types';

/** ADR-0044: following a trip through its share link. */
export const followersApi = {
  subscribeByEmail: (shareToken: string, email: string, locale: string) =>
    api.post(`/follow/share/${shareToken}/email`, { email, locale }),
  confirmEmail: (subscriberToken: string) =>
    api.post(`/follow/email/${subscriberToken}/confirm`),
  unsubscribeEmail: (subscriberToken: string) =>
    api.post(`/follow/email/${subscriberToken}/unsubscribe`),
  status: (shareToken: string) =>
    api.get<{ following: boolean }>(`/follow/share/${shareToken}`).then(r => r.data.following),
  follow: (shareToken: string) => api.post(`/follow/share/${shareToken}`),
  unfollow: (shareToken: string) => api.delete(`/follow/share/${shareToken}`),
  followedTrips: () => api.get<FollowedTrip[]>('/follow/trips').then(r => r.data),
};
